import { DropDown, SearchBar, NewSiteButton } from "../components/textField";
import TopNav from "../components/topnav";
import EnhancedTable from "../components/newTable";
import { useState, useEffect, useMemo } from "react";
import Edit from '../assests/edit.png';
import { content } from "../utils/data";
import { createBuilding, getBuilding, getBuildingCode, editBuilding } from "../api/serverApi";
import { Link, useLocation } from 'react-router-dom';
import { CreateBuilding, EditBuilding } from "../components/dropdowns";
import SiteModal from "../components/siteCreationModal";
import Spinner from "../components/spinner";
import { Button } from "@mui/material";
import { useCookies } from "react-cookie";
import StatusModal from "../components/statusModal";
import { getValidAccessToken } from "../services/garphService";
import { useMsal } from "@azure/msal-react";
import * as microsoftTeams from "@microsoft/teams-js";

const Building = () => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [siteNo, setSiteNo] = useState('');
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { siteId, siteName, state, locationName } = location.state || {};
  const responseData = [{ site_id: siteId, name: siteName, state: state, location_name: locationName }];
  const [buildingCode, setBuildingCode] = useState('');
  const [buildingCodeId, setBildingCodeId] = useState('');
  const [buildingCodeName, setBuildingCodeName] = useState('');
  const [buildingId, setBildingId] = useState('');
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editedBuildingCode, setEditedBuildingCode] = useState('');
  const [buldingCodeDrop, setBuildingCodeDrop] = useState([]);
  const [codeId, setCodeId] = useState('');
  const [searchText, setSearchText] = useState('');
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const { instance, accounts } = useMsal();
  const [cookies, setCookie] = useCookies([
    "email",
    "firstName",
    "lastName",
    "roleName",
    "roleId",
    "accessToken",
    "fullname"
  ]);

  const handleOpen = () => {
    setIsEditing(false);  // Ensure that isEditing is set to false for creating a new site
    setOpen(true);         // Open the modal for site creation
    // Optionally reset state-related fields
  };
  const handleClose = () => setOpen(false);
  // Utility to detect Teams context
  const isInTeams = () => {
    try {
      return window.parent !== window.self;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const fetchBuildingData = async () => {
      if (!siteId) return;
      try {
        setLoading(true);
        let token;
        if (isInTeams()) {
          token = await new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken({
              successCallback: resolve,
              failureCallback: reject,
              resources: ['https://graph.microsoft.com']
            });
          });
        } else {
          token = await getValidAccessToken(instance, accounts);
        }
        const res = await getBuilding(siteId, token);
        console.log("API response:", res.data);
        setFilteredRows(Array.isArray(res.data.buildings) ? res.data.buildings : []);
        setSiteNo(siteId);
      } catch (err) {
        const message = err.response?.data?.detail || 'An unexpected error occurred';
        setResponseMessage(message);
        setModalOpen(true);
      } finally {
        setLoading(false);
      }
    };
    fetchBuildingData();
  }, [siteId]);

  useEffect(() => {
    if (!siteId) return; // Prevent API call with undefined siteId

    getBuildingCode(siteId)
      .then((response) => {
        setBuildingCodeDrop(response.data);
        setCodeId('');
        console.log(response);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }, [siteId]);

  const handleBuildingCode = (event) => {
    setBuildingCode(event.target.value);

  };
  const handleBuildingName = (event) => {
    setBildingCodeId(event.target.value);

  };

  const rowsWithActions = useMemo(() => {
    return (filteredRows || []).map((row) => ({
      ...row,
      actions: (
        <div className="flex">
          <img
            src={Edit}
            alt="Edit"
            style={{ width: "20px", cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleEdit(row.building_id)}
          />
        </div>
      ),
    }));
  }, [filteredRows]);

  const rowsFiltered = rowsWithActions.filter((row) => {
    const matchCodeId = codeId ? row.building_id === codeId : true;

    // Build searchable content
    const searchableContent = [
      row.building_name,
    ]
      .map(val => String(val || '').toLowerCase().trim())
      .join(' ');

    const matchSearch = searchText
      ? searchableContent.includes(searchText.trim().toLowerCase())
      : true;

    return matchCodeId && matchSearch;
  });

  const handleSubmit = async () => {
    try {
      setLoading(true);
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ['https://graph.microsoft.com']
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      const data = {
        building_name: buildingCodeId,
      };
      const response = await createBuilding(siteId, data, token);
      console.log("✅ Building created:", response.data);
      setResponseMessage(response.data?.message || 'Building created successfully');
      setIsSuccess(true);
      setModalOpen(true);
      setOpen(false);
      resetSurveyForm();
      const res = await getBuilding(siteId, token);
      console.log("API response:", res.data);
      setFilteredRows(Array.isArray(res.data.buildings) ? res.data.buildings : []);
      setSiteNo(siteId);
    } catch (error) {
      console.error("❌ Error creating building:", error);
      const msg = error.response?.data?.detail || "An unexpected error occurred.";
      setResponseMessage(msg);
      setIsSuccess(false);
      setModalOpen(true);
      resetSurveyForm();
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  const resetSurveyForm = () => {
    setBuildingCode('');
    setBildingCodeId('');

  };

  const handleEdit = (building_id) => {
    const site = filteredRows?.find(site => site.building_id === building_id);

    if (site) {
      setBuildingCodeName(site.building_name || '');
      // setEditedBuildingCode(site.building_code);
      setBildingId(site.building_id || '');
      console.log(buildingCodeName)
      setIsEditing(true);
      setOpen(true);

      console.log('Matched State:', site.state);
      console.log('Edit clicked for site:', site);
    } else {
      console.error('Site not found with ID:', siteId);
    }
  };
  const handleBuildingEdit = async () => {
    try {
      setLoading(true);
      let token;
      if (isInTeams()) {
        token = await new Promise((resolve, reject) => {
          microsoftTeams.authentication.getAuthToken({
            successCallback: resolve,
            failureCallback: reject,
            resources: ['https://graph.microsoft.com']
          });
        });
      } else {
        token = await getValidAccessToken(instance, accounts);
      }
      const data = {
        building_name: buildingCodeName,
      };
      const response = await editBuilding(buildingId, data, token);
      console.log("✅ Building updated:", response.data);
      setResponseMessage(response.data?.message || 'Building updated successfully');
      setIsSuccess(true);
      setModalOpen(true);
      setOpen(false);
      const res = await getBuilding(siteId, token);
      console.log("API response:", res.data);
      setFilteredRows(Array.isArray(res.data.buildings) ? res.data.buildings : []);
      setSiteNo(siteId);
    } catch (error) {
      console.error("❌ Error updating building:", error);
      const msg = error.response?.data?.detail || "An unexpected error occurred.";
      setResponseMessage(msg);
      setIsSuccess(false);
      setModalOpen(true);
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

return (
    <>
      <div>
        <TopNav />
      </div>
      <div className="px-[35px] py-2 font-bold text-2xl"><Link to='/sitecreation'>Site Creation</Link> {`>`} {state} {'>'} {locationName} {`>`} {siteName} {`>`} Pre & Post Construction </div>
      <div className="flex flex-wrap px-4 md:px-[35px] gap-2 md:gap-x-3 items-center">
        <div className="w-full sm:w-auto flex-shrink-0">
          <SearchBar
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)} />
        </div>
        <div className="w-full sm:w-auto flex-shrink-0">
          <DropDown
            title="Building Name"
            placeholder="None"
            responseData={buldingCodeDrop}
            labelKey="building_name"
            valueKey="building_id"
            value={codeId}
            onChange={(e) => {
              setCodeId(e.target.value);
            }}

          />
        </div>

        <div className="w-full sm:w-auto flex-shrink-0">
          <Button
            variant="contained"
            onClick={() => {
              setCodeId('');
            }}

            sx={{
              backgroundColor: '#1381B5',
              '&:hover': { backgroundColor: '#0f6c99' },
              width: "95px",
              height: '40px',
              fontSize: '10px',
              whiteSpace: 'nowrap', // prevents text wrapping
            }}
          >
            Clear All
          </Button>
        </div>

        <div className="w-full sm:w-auto py-2 sm:ml-auto flex-shrink-0">
          <NewSiteButton Name="Add Building" handleOpen={handleOpen} />
        </div>
      </div>
      <SiteModal
        open={open}
        handleClose={() => setOpen(false)}
        title={isEditing ? "Edit Building" : "Create New Building"}
        handleSubmit={isEditing ? handleBuildingEdit : handleSubmit}
        formContent={isEditing ? (
          <EditBuilding
            stateName={state}
            location={locationName}
            siteName={siteName}
            nameBuilding={buildingCodeName}
            onChangeBuildingName={(e) => setBuildingCodeName(e.target.value)}
            isEditing={isEditing} />) :
          (
            <CreateBuilding
              stateName={state}
              location={locationName}
              siteName={siteName}
              nameBuilding={buildingCodeId}
              onChangeBuildingName={handleBuildingName}
              isEditing={isEditing} />
          )
        }
      />
      <div className="py-2 px-[35px]">
        <EnhancedTable
          rows={rowsFiltered}
          header={content.building} // or whichever headers you're using
        />
      </div>
      {loading && <Spinner />}
      <StatusModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        message={responseMessage}
        isSuccess={isSuccess}
      />
    </>
  )
}

export default Building